import { Component, OnInit, Input, AfterViewInit, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { ClassService, ConfigService, ScriptLoaderService } from './../../../../../../_services';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { SwalComponent, SwalPartialTargets } from '@toverux/ngx-sweetalert2';
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Category } from '../../../../../../_models/Interfaces/category';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';


@Component({
    selector: 'app-configs-category-create-modal',
    templateUrl: './configs-category-create-modal.component.html',
    styles: []
})
export class ConfigsCategoryCreateModalComponent implements OnInit, AfterViewInit, OnChanges {
    @Input() category_id: number;
    public category: Object = { name: "", short_name: "", description: "", type: "" };
    createform: FormGroup;
    public errors: string[];


    @BlockUI() blockUI: NgBlockUI;
    @ViewChild('successSwal') private successSwal: SwalComponent;
    @ViewChild('errorSwal') private errorSwal: SwalComponent;
    @ViewChild('errorsListSwal') private errorsListSwal: SwalComponent;

    constructor(private _configService: ConfigService,
        private _script: ScriptLoaderService,
        protected fb: FormBuilder,
  			      /*private _modalService: NgbModal*/) {
        this.createform = fb.group({
            'name': ['', Validators.compose([Validators.required])],
            'short_name': ['', Validators.compose([Validators.required])],
            'description': ['', Validators.compose([Validators.nullValidator])],
            'type': ['income', Validators.compose([Validators.required])],
            'in_pool': [1, Validators.compose([Validators.required])]
        });
    }

    ngOnInit() { }

    ngAfterViewInit() {
        this._script.loadScripts('app-configs-modal', ['assets/demo/demo2/custom/crud/forms/widgets/bootstrap-select.js']);

    }

    ngOnChanges(changes: SimpleChanges) { }


    createCategory() {
        this.blockUI.start();
        this.category['name'] = this.createform.controls.name.value;
        this.category['short_name'] = this.createform.controls.short_name.value;
        this.category['description'] = this.createform.controls.description.value;
        this.category['type'] = this.createform.controls.type.value;
        this.category['in_pool'] = this.createform.controls.in_pool.value;
        this._configService.postCategory(this.category).subscribe(response => {
            this.blockUI.stop();
            this.successSwal.text = response.message;
            this.successSwal.show();

        }, error => {
            this.errors = error.error.error.errors;
            this.blockUI.stop();
            this.errorsListSwal.show();
        }, () => {

        });
    }

    reload() {
        window.location.reload();
    }
}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/theme/pages/aside-left-display-disabled/configs/configs-modals/category-create-modal/configs-category-create-modal.component.ts